import type { Api } from '@vitejs/plugin-vue'
import { request } from '../http'

/**
 *  验证手机号是否已注册
 */
export function checkPhone(params: any) {
  const methodInstance = request.Get('/user/users/registerVerifyPhone', { params: { mobile: params } })
  methodInstance.meta = {
    authRole: null,
  }
  return methodInstance
}

/**
 *  校验手机验证码
 */
export function checkMobileCode(data: any) {
  const methodInstance = request.Post('/user/membercenter/checkMobileCode', data)
  methodInstance.meta = {
    authRole: null,
  }
  return methodInstance
}

/**
 *  行业
 */
export function getListBySite() {
  const methodInstance = request.Get('/user/common/workbusiness/getListBySite?site=seaarea.com')
  methodInstance.meta = {
    authRole: null,
  }
  return methodInstance
}

/**
 *  账号注册
 */
export function registerForGpt(data: Api.Register.Info) {
  const methodInstance = request.Post<Service.ResponseResult<Api.Login.Info>>('/user/users/registerForGpt', { ...data, sourceSite: '会员中心' })
  methodInstance.meta = {
    authRole: null,
  }
  return methodInstance
}
